function centerResultsBannerCards() {
  document.querySelectorAll('.results-banner__grid').forEach((grid) => {
    const peek = parseFloat(getComputedStyle(grid).getPropertyValue('--rb-card-peek-mobile')) || 32;
    const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    const outerWidth = grid.parentElement.getBoundingClientRect().width;
    if (!outerWidth) return;
    const pad = peek + gap;
    const cardWidth = Math.max(outerWidth - pad * 2, 100);
    grid.style.setProperty('--rb-card-width-mobile-px', cardWidth + 'px');
    grid.style.setProperty('--rb-card-padding-mobile-px', pad + 'px');
  });
}

centerResultsBannerCards();

let resultsBannerResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resultsBannerResizeTimer);
  resultsBannerResizeTimer = setTimeout(centerResultsBannerCards, 150);
});

document.addEventListener('shopify:section:load', centerResultsBannerCards);
